import { Route, Routes } from "react-router-dom";
import { AdminLayout, PrivateLayout } from "../layouts";
import { Admin, Private, Public } from "../pages";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Public.Login />} />
      <Route path="/get-started" element={<Public.SignUp />} />

      <Route path="/" element={<PrivateLayout />}>
        <Route index element={<Private.Home />} />
        <Route
          path="/lessons/:id/:moduleName/:percent"
          element={<Private.Lessons />}
        />
        <Route path="/player/:id" element={<Private.PlayerPage />} />
        <Route path="/profile" element={<Private.Profile />} />
        <Route path="/profile/packages" element={<Private.Packages />} />
        <Route
          path="/profile/packages/checkout/:price"
          element={<Private.CheckOut />}
        />
      </Route>

      <Route path="/admin/*" element={<AdminLayout />}>
        <Route index element={<Admin.Students />} />
        <Route path="students" element={<Admin.Students />} />
        <Route path="users" element={<Admin.Collaborators />} />
        <Route path="modules" element={<Admin.Modules />} />
        <Route path="lessons" element={<Admin.Lessons />} />
        <Route path="packages" element={<Admin.BillPackages />} />
        <Route path="assessments">
          <Route index element={<Admin.Assessment />} />
          <Route path="new/:id" element={<Admin.NewAssessment />} />
        </Route>
        <Route path="documents" element={<Admin.Documents />} />
        <Route path="settings" element={<Admin.Settings />} />
        <Route path="bills" element={<Admin.Bills />} />
      </Route>
    </Routes>
  );
};
